require('./bootstrap');

import Vue from 'vue';
//Rutas del website
import Router from './router.js';

//Librerias globales
import Library from './libs.js';
Vue.use(Library);

//Componentes del website
import components from './components/components.js';
Vue.use(components);

// == Lenguajes del sitio web ==
import VueI18n from 'vue-i18n';
import messages from './langs.js';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'es',
  messages: messages // set locale messages
})
// == ==

window.Vue=Vue;

//Instancia principal
const app = new Vue({
  el: '#app',
  router:Router,
  methods: {
    subDomain(){
      return window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
    },

    selectLang(){
      var subDomain = this.subDomain();
      // console.log(subDomain);

      if(subDomain){ // Solo cuando está ONLINE
        if(subDomain == 'en'){
          this.$i18n.locale = 'en';
        }else{
          this.$i18n.locale = 'es';
        }
      }
    },

    changeLocale(lang = null){
      if(lang == 'en'){
        this.$i18n.locale = 'en';
      }else{
        this.$i18n.locale = 'es';
      }
    },

    changeLangBTN(lang){
      this.changeLocale(lang);
    },

    // changeLangBTN(lang){ // Cambiar la URL (recargar la pagina). El metodo "selectLang()" se encargará de seleccionar el idioma a cargar, a menos que sea local.
    //   // console.log(lang);
    //   var subDomain = this.subDomain();
    //   var protocol = window.location.protocol + '//';

    //   if(subDomain != false){ // Solo cuando está ONLINE
    //     var fullURL = window.location.href.split(protocol);
    //     var arrayURL = fullURL[1].split("/#/");

    //     // console.log(arrayURL[0] + '/#/' + arrayURL[1]);
    //     if(lang == 'en' && this.$i18n.locale != 'en'){
    //       window.location.replace( protocol + 'en.esloventanas.com/#/' + arrayURL[1] );
    //     }
    //     else if(lang == 'es' && this.$i18n.locale != 'es'){
    //       window.location.replace( protocol + arrayURL[0].substring(3) + '/#/' + arrayURL[1] );
    //     }
    //   }
    //   else{ // Solo cuando está en LOCAL
    //     // console.log('ES LOCAL');
    //     this.changeLocale(lang);
    //   }
    // },
  },
  beforeMount(){
    // this.selectLang();
  },
  mounted:function(){
    //console.log(Vue.paypal);
  },
  mode: 'history',
  i18n,
});
